import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { K, CHECKLIST } from "@/lib/catalogue";

// Personal reminders only — never a quantity. Favourite is a separate flag so an item can be ★ and 🛒 at once.
export default function ChecklistBar({ item, onChanged, compact = false }) {
  const [busy, setBusy] = useState(false);
  const patch = async (body) => {
    setBusy(true);
    try { const { data } = await axios.patch(`${K}/items/${item.id}/status`, body); onChanged(data); }
    catch (e) { toast.error("Could not update", { description: e?.response?.data?.detail }); }
    finally { setBusy(false); }
  };
  return (
    <div className={`flex flex-wrap gap-1.5 ${compact ? "" : "gap-2"}`} data-testid="checklist-bar">
      <button type="button" disabled={busy} onClick={() => patch({ favourite: !item.favourite })} data-testid="check-favourite" data-on={!!item.favourite}
        className={`inline-flex items-center gap-1.5 rounded-full border px-3 h-9 text-xs font-bold transition-colors ${item.favourite ? "text-amber-300 bg-amber-500/15 border-amber-500/40" : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>
        <Star className={`w-3.5 h-3.5 ${item.favourite ? "fill-amber-300" : ""}`} /> Favourite
      </button>
      {CHECKLIST.filter(([k]) => k !== "favourite").map(([k, l, icon, tone]) => {
        const on = item.checklist_status === k;
        return (
          <button key={k} type="button" disabled={busy} onClick={() => patch({ checklist_status: on ? "none" : k })} data-testid={`check-${k}`} data-on={on}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 h-9 text-xs font-bold transition-colors ${on ? tone : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>
            <span aria-hidden>{icon}</span> {l}
          </button>
        );
      })}
    </div>
  );
}
